"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormNavigation = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const useFormNavigation = (props) => {
    const { showHiddenSteps, setActiveStep } = props;
    const navigate = (0, react_router_dom_1.useNavigate)();
    return (0, react_1.useCallback)((stepNumber, options) => {
        if (options === null || options === void 0 ? void 0 : options.ignoreHiddenSteps) {
            showHiddenSteps();
        }
        setActiveStep(stepNumber);
        if (options === null || options === void 0 ? void 0 : options.navigateToForm) {
            navigate('/');
        }
    }, [showHiddenSteps, navigate]);
};
exports.useFormNavigation = useFormNavigation;
